export default __webpack_public_path__ + "static/media/AG7.320556fe.jpg";